module.exports = __webpack_public_path__ + "img/advertisement.e667b11c.png";